import { Suspense, type ReactElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES, isLazyPage } from './routeTable';

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export function CustomDomainRouter() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        {ROUTES.map(([path, target]) => {
          const Page = isLazyPage(target) ? target : null;
          return <Route key={path} path={path} element={Page ? <Page /> : target as ReactElement} />;
        })}
      </Routes>
    </Suspense>
  );
}
